// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"3a504f92","105":"eda16fd9","148":"49f204a5","370":"25e6f1db","415":"28982010","528":"d19bef93","576":"ae736f1c","600":"5a5faaa8","721":"e9612f91","774":"0dedb0b4","871":"8b97a0d0","928":"1dd3c2cf"}[chunkId] + ".chunk.js";
};